import Axios from "../helper/appConfig";

export const getAllServiceList = async () => {
  const body = {
    search: [
      {
        searchfield: "type",
        searchvalue: "service",
        criteria: "eq",
        datatype: "text",
      },
      {
        searchfield: "status",
        searchvalue: "active",
        criteria: "eq",
        datatype: "text",
      },
      {
        searchfield: "property.onlineavailibility",
        searchvalue: true,
        criteria: "eq",
        datatype: "boolean",
      },
    ],
    sort: {
      updatedAt: -1,
    },
  };
  return await Axios.post("api/services/filter", body);
};

export const getDataServiceList = async (id) => {


  return await Axios.get("api/services/" + id);
};